import { t, tp } from "@app/lib/compta/i18n";
import {
  libelleAppelOutilMetier,
  libellesAffichageOutilGoogle,
} from "@app/lib/compta/libelles_outils";
import type { AgentMCPActionType } from "@app/types/actions";
import { asDisplayName } from "@app/types/shared/utils/string_utils";

type ActionWithDisplayLabel = Pick<
  AgentMCPActionType,
  | "displayLabels"
  | "functionCallName"
  | "internalMCPServerName"
  | "params"
  | "toolName"
>;

export function getActionOneLineLabel(
  action: ActionWithDisplayLabel,
  context: "running" | "done" = "done"
): string {
  if (
    action.internalMCPServerName === "sandbox" &&
    action.toolName === "add_egress_domain" &&
    typeof action.params?.domain === "string"
  ) {
    const domain = action.params.domain;
    return context === "running"
      ? tp("Requesting access to {domain}", { domain })
      : tp("Request access to {domain}", { domain });
  }

  // Fork : Gmail et Google Agenda en français, y compris pour une action dont le libellé
  // anglais est déjà stocké (front/lib/compta/libelles_outils.ts).
  const libellesGoogle = libellesAffichageOutilGoogle(
    action.internalMCPServerName,
    action.toolName,
    action.params
  );
  if (libellesGoogle) {
    return libellesGoogle[context];
  }

  return (
    action.displayLabels?.[context] ??
    (action.functionCallName
      ? // Fork : libellé français d'un outil métier (front/lib/compta/libelles_outils.ts).
        (libelleAppelOutilMetier(action.functionCallName) ??
        asDisplayName(action.functionCallName))
      : t("Tool"))
  );
}
